import { z } from "zod";

// export const formSchema = z.object({
//     first_name: z.string().min(1, "First name is required"),
//     last_name: z.string().min(1, "last name is required"),
//     email: z.string().email("Invalid email address"),
//     phone: z
//         .string()
//         .refine(
//             (value) =>
//                 /^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?\#(\d{4}|\d{3}))?$/.test(
//                     value ?? ""
//                 ),
//             "Please enter Valid Phone Number"
//         ),
//     postcode: z.string().min(1, "Postcode is required"),

//     message: z.string().optional(),
//     external_handle_size: z.string().optional(),
//     configuration: z.string(),
//     configuration_type: z.string(),
//     opening_direction: z.string(),
//     external_door_style: z.string(),
//     external_door_colour: z.string(),
//     internal_door_colour: z.string(),
//     external_door_colour_type: z.string(),
//     cill: z.string(),
//     hinge: z.string(),
//     glass_options: z.string(),
//     escutcheon: z.string(),
//     e_key_entry: z.string(),
//     spy_hole: z.string(),
//     house_number: z.string().max(3, "House Number should be 3 letters"),
//     external_handle_style: z.string(),
//     internal_handle_style: z.string(),
//     house_number_style: z.string(),
//     internal_custom_ral_color: z.string().optional(),
//     external_custom_ral_color: z.string().optional(),
//     extenders_top: z.string(),
//     extenders_side: z.string(),
//
// })


function validateSidelightWidth(width, factor = 1,ctx) {
    const adjustedWidth = width / factor;
    if (!(300 <= adjustedWidth && adjustedWidth <= 1200)) {
        ctx.addIssue({
            message: `Each Sidelight Width should be between 300mm and 1200mm. Currently received ${adjustedWidth}mm`,
            code: z.ZodIssueCode.custom,
            path: ['aperture_width'],
        });
    }
}
function validateSidelightHeight(data,ctx) {

    const {configuration,aperture_height,height} = data

    const height_difference = aperture_height - height;

    if(['d','e','f'].includes(configuration.type)){
        if (!(300 <= height_difference && height_difference <= 1200)){
            ctx.addIssue({
                message: `Top light Height should be between 300mm and 1200mm`,
                code: z.ZodIssueCode.custom,
                path: ['aperture_height'],
            });
        }

    }else if(height_difference !==0){
        ctx.addIssue({
            message: `With the selected configuration Sidelight should have the same height as the door`,
            code: z.ZodIssueCode.custom,
            path: ['aperture_height'],
        });
    }

}

export const formSchema = z.object({
    first_name: z.string().min(1, "First name is required"),
    last_name: z.string().min(1, "last name is required"),
    email: z.string().email("Invalid email address"),
    // iOS contact autofill can insert a UK mobile without its +44 or leading 0
    // ("7494767191"); restore the 0 so it validates.
    phone: z.preprocess(
        (value) =>
            typeof value === "string" && /^7\d{9}$/.test(value.replace(/[\s-]/g, ""))
                ? `0${value.replace(/[\s-]/g, "")}`
                : value,
        z.string()
    )
        .refine(
            (value) =>
                /^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?\#(\d{4}|\d{3}))?$/.test(
                    value ?? ""
                ),
            "Please enter Valid Phone Number"
        ),
    postcode: z.string().min(1, "Postcode is required"),
    message: z.string().optional(),
    external_handle_length: z.string().optional(),
    configuration: z.string(),
    configuration_type: z.string(),
    opening_direction: z.string(),
    external_door_style: z.string(),
    external_door_colour: z.string(),
    internal_door_colour: z.string(),
    slab: z.string(),
    external_door_colour_type: z.string(),
    cill: z.string(),
    hinge: z.string(),
    glass_option: z.string(),
    escutcheon: z.string(),
    e_key_entry: z.string(),
    spy_hole: z.string(),
    house_number: z.string().max(3, "House Number should be 3 letters"),
    external_handle_style: z.string(),
    internal_handle_style: z.string(),
    house_number_style: z.string(),
    internal_custom_ral_color: z.string().optional(),
    external_custom_ral_color: z.string().optional(),
    top_frame_extender: z.string(),
    side_frame_extender: z.string(),
    oxide_frame_colour: z.string().optional(),
    internal_door_colour_type: z.string().optional(),
    external_slab_colour_type: z.string().optional(),
    internal_slab_colour_type: z.string().optional(),
    internal_slab_colour: z.string().optional(),
    panel: z.string().optional(),
    external_handle_colour: z.string().optional(),
    height: z
        .string()
        .min(1, "Height is required")
        .transform((value) => parseFloat(value))
        .refine((value) => !isNaN(value), "Height must be a number")
        .refine((value) => value >= 1900 && value <= 2750, "Height must be between 1900mm and 2750mm"),
    width: z
        .string()
        .min(1, "Width is required")
        .transform((value) => parseFloat(value))
        .refine((value) => !isNaN(value), "Width must be a number")
        .refine((value) => value >= 875 && value <= 1200, "Width must be between 875mm and 1200mm"),
    aperture_height: z
        .string()
        .min(1, "Aperture height is required")
        .transform((value) => parseFloat(value))
        .refine((value) => !isNaN(value), "Aperture height must be a number"),
        aperture_width: z
        .string()
        .min(1, "Aperture width is required")
        .transform((value) => parseFloat(value))
        .refine((value) => !isNaN(value), "Aperture width must be a number"),
}).superRefine((data, ctx) => {
    const each_sidelight_width  = (data.aperture_width - data.width);
    // height validation
    validateSidelightHeight(data,ctx)

    // width validation
    switch (data.configuration) {
        case 'a':
        case 'd':
            validateSidelightWidth(each_sidelight_width, 2, ctx);
            break;

        case 'b':
        case 'c':
        case 'e':
        case 'f':
            validateSidelightWidth(each_sidelight_width, 1, ctx);
            break;

        case 'none':
            if(each_sidelight_width !==0) {
                ctx.addIssue({
                    message: `With the selected configuration Sidelight should have the same width as the door`,
                    code: z.ZodIssueCode.custom,
                    path: ['aperture_width'],
                });
            }
    }
});


export const defaultValues = {
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    postcode: "",
    // TODO
    height: '',
    width: '',
    aperture_height: '',
    aperture_width: '',
    message: "",
    configuration: "none",
    configuration_type: "",
    opening_direction: "Hung on left",
    external_door_style: "sumatra",
    external_door_colour: "ral_7016",
    internal_door_colour: "ral_7016",
    slab: 'ral_7016',
    external_door_colour_type: "standard",
    internal_door_colour_type: "standard",
    cill: "",
    glass_option: "clear",
    escutcheon: "square stainless steel",
    e_key_entry: "",
    spy_hole: "",
    house_number: "",
    external_handle_style: "Flat_Silver",
    external_handle_length:'1600',
    internal_handle_style: "Square_Silver",
    house_number_style: "",
    external_custom_ral_color: "",
    internal_custom_ral_color: "",
    hinge: "silver",
    oxide_frame_colour:'ral_7016',
    // extenders_top: "",
    // extenders_side: "",
    side_frame_extender:'',
    top_frame_extender:''
};



// none integra
// hung on right & configuration === a || b : -450, if not a || b should be -200
// hung on left & configuration === a || c : 1500, if not a || c should be 1250

// for integra only
// hung on right 180
// hung on left 990

